import React, { useState, useEffect, useMemo } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { SUBMIT_VIEWING_REQUEST } from "../api/constants";
import Swal from "sweetalert2";

function ConfirmTourModal({ show, handleClose, tourData,listing_type }) {
  console.log(listing_type)
  const token = localStorage.getItem("token");

  // ✅ memoize user so reference does NOT change every render
  const user = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user") || "null");
    } catch {
      return null;
    }
  }, []);

  const isLoggedIn = !!(user && token);

  const [formData, setFormData] = useState({
    guest_name: "",
    guest_email: "",
    guest_phone: "",
    message: "",
    wants_financing_info: false,
  });

  // ✅ FIXED EFFECT (no infinite loop)
  useEffect(() => {
    if (!isLoggedIn || !user) return;

    setFormData(prev => ({
      ...prev,
      guest_name: `${user.first_name || ''} ${user.last_name || ''}`.trim(),
      guest_email: user.email || '',
      guest_phone: user.phone_number || '',
    }));
  }, [isLoggedIn]); // 👈 ONLY this

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(SUBMIT_VIEWING_REQUEST, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        body: JSON.stringify({
          ...formData,
          ...tourData,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Failed to submit viewing request");
      }

      if (data.status) {
        Swal.fire({
          title: "Success!",
          text: data.message,
          icon: "success",
          confirmButtonText: "OK",
          confirmButtonColor: "#0abab5",
        });
      }

      handleClose();
    } catch (err) {
      console.error("Viewing request error:", err.message);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      scrollable
      className="tour-modal confirm-tour-modal"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title>Contact a {listing_type=='rent'?'Rental':"Buyer's"} Agent</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          {!isLoggedIn && (
            <>
              <Form.Group className="mb-3">
                <Form.Label>Name *</Form.Label>
                <Form.Control
                  type="text"
                  name="guest_name"
                  value={formData.guest_name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Email *</Form.Label>
                <Form.Control
                  type="email"
                  name="guest_email"
                  value={formData.guest_email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Phone *</Form.Label>
                <Form.Control
                  type="tel"
                  name="guest_phone"
                  value={formData.guest_phone}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </>
          )}

          <Form.Group className="mb-3">
            <Form.Label>Message *</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Check
              type="checkbox"
              name="wants_financing_info"
              checked={formData.wants_financing_info}
              onChange={handleChange}
              label="I want financing information"
            />
          </Form.Group>

          <Button type="submit" className="w-100 custom-bttn">
            Contact an Agent
          </Button>
                    <p className="disclaimer-text">
            By pressing Contact an agent, you agree that Real Estate Group and its affiliates,
            and real estate professionals may call/text you about your inquiry, which may
            involve use of automated means and prerecorded/artificial voices. You don't
            need to consent as a condition of buying any property, goods or services.
            Message/data rates may apply. You also agree to our Terms of Use. Real Estate
            does not endorse any real estate professionals. We may share information about
            your recent and future site activity with your agent to help them understand what
            you're looking for in a home.
          </p>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default ConfirmTourModal;